import React from "react";
import { useHardwareProductsQuery } from "generated/graphql";
import { arrayUnique } from "utilities/arrayUtils";

/**
 * This component preloads the various image urls available for
 * devices from the product catalog service.
 *
 * This ensures that the browser has already cached a copy of the image,
 * so that the pages that need to render the image can do so instantaneously.
 *
 * This component does not add anything to the rendered markup.
 */
const PreloadCatalogImages: React.FC = () => {
  const { data, fetching } = useHardwareProductsQuery();

  if (
    fetching ||
    !data ||
    !data.hardwareProducts ||
    !data.hardwareProducts.length
  ) {
    return null;
  }

  let urls: Array<string> = data.hardwareProducts.reduce((acc, product) => {
    if (product.images.length) {
      const images = product.images.map(i => i.url);
      acc = acc.concat(images);
    }

    return acc;
  }, [] as Array<string>);

  urls = arrayUnique(urls);

  let images: Array<HTMLImageElement> = [];
  urls.forEach((url, i) => {
    images[i] = new Image();
    images[i].src = url;
  });

  return null;
};

export default PreloadCatalogImages;
